import React, { createContext, useState, useEffect, useContext } from "react";

// Create the context
const TokenContext = createContext();

// Create a provider component
export const TokenProvider = ({ children, initialId,initialToken }) => {
  const [id, setId] = useState(initialId);
  const [token,setToken] = useState(initialToken)

  useEffect(() => {
    if (!id) {
      setId(initialId)
    }
  }, [id]);

  return (
    <TokenContext.Provider value={{ id, setId ,token,setToken}}>
      {children}
    </TokenContext.Provider>
  );
};

// Custom hook for consuming the context
export const useToken = () => useContext(TokenContext);
